export default __webpack_public_path__ + "static/designing-new-navigation-header-068c47d4e485f52d4c9e70fb82f1ef2719e4bf92c63da9c16945b1b000331f56.png";